import classNames from 'classnames'

interface CardType {
  children: React.ReactNode
  clx: string
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  className?: string
}

const Card = ({ children, clx, onClick, className }: CardType): JSX.Element => {
  return (
    <div onClick={onClick} className={classNames(className, clx, 'rounded-[6px] border border-gray-100 p-[16px]')}>
      {children}
    </div>
  )
}

export default Card
